import { render, staticRenderFns } from "./WidgetWebSocketControlPanel.vue?vue&type=template&id=2f38cb01&scoped=true"
import script from "./WidgetWebSocketControlPanel.vue?vue&type=script&lang=js"
export * from "./WidgetWebSocketControlPanel.vue?vue&type=script&lang=js"
import style0 from "./WidgetWebSocketControlPanel.vue?vue&type=style&index=0&id=2f38cb01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f38cb01",
  null
  
)

export default component.exports